import React from "react";
import { Table } from "semantic-ui-react";
import { connect } from "react-redux";
import { fetchEvents, createEvent } from "../../actions";
import { hasEvents } from "../helpers/EventUtils";
import TableList from "./TableList";

class GameResultTable extends React.Component {
  renderResultsTable = () => {
    return (
      //      <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
      //   <a href="https://www.bridgewebs.com/cgi-bin/bwoo/bw.cgi?club=bridgeclublive&pid=display_past"  target='_blank' rel='noopener noreferrer'>
      //   <Button
      // negative>Click for Bridge Club Live</Button></a>

      //   </div>

      <div>
        <Table basic="very" striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Date</Table.HeaderCell>
              {/*<Table.HeaderCell>Name</Table.HeaderCell>*/}
              <Table.HeaderCell>Location</Table.HeaderCell>
              <Table.HeaderCell>Club</Table.HeaderCell>
              <Table.HeaderCell>Detailed Results</Table.HeaderCell>
              <Table.HeaderCell>Hands</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <TableList
            showRows={this.props.showRows}
            bridgeEvents={this.props.events}
          />
        </Table>
      </div>
    );
  };

  render() {
    return hasEvents(this.props) ? this.renderResultsTable() : <div></div>;
  }
}

const mapStateToProps = (state) => {
  return { events: state.events };
};

export default connect(mapStateToProps, { fetchEvents, createEvent })(
  GameResultTable
);
